// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
export const delete_account = {
  button: {
    submit: '削除',
  },
  input: {
    placeholder: {
      email: 'メールアドレス',
    },
    label: {
      email: 'メールアドレス',
    },
  },
  label: {
    title: 'アカウントを削除',
    delete_success: 'アカウント削除完了',
  },
  alert: {
    delete_success: 'アカウント削除が完了しました。',
  },
};
